<template>
    <div class="popup type2" :class="{ active: popupShow }">
        <div class="popup__inner">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>회원 아이디 찾기</h2>
                    <button type="button" class="popup__close" @click="popupBtn"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <p class="popup__info-tit">가입하신 아이디는 <span class="c-blue">{{getId}}</span> 입니다.</p>
                    <div class="botton-wrap">
                        <a href="javascript:;" class="main-button c-main" @click="confirm">확인</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                popupShow: false,
                getId: '',
            }
        },
        components: {
        },
        mounted() {
        },
        methods: {
            popupBtn() {
                this.popupShow = !this.popupShow
            },
            confirm(){
                this.popupShow = false
                this.$router.push('/kr/login')
            }
        },
    }
</script>